/* eslint-disable  */
import React from 'react'
import axios from 'axios'
import ReactCrop from 'react-image-crop'
import { v4 as uuidv4 } from 'uuid'
import { Modal, Button } from 'react-bootstrap'
import getPreSignedURLForImageService from '../../Services/Queries/getPreSignedURLForImageService'
import { decode as base64_decode, encode as base64_encode } from 'base-64'
class ImageUpload extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      size1: 100,
      src: '',
      // imageSizeLimitModal: false,
      cropImage: false,
      crop: {
        unit: '%',
        width: 30,
        aspect: this.props.circularCrop
          ? 1
          : props.selectedContentType == 'ShortByte' &&
            (props.shortByteTemplateType == 'Small' || props.shortByteTemplateType == 'Medium')
          ? 9 / 16
          : 16 / 9,
      },
    }
  }

  // hideImageSizeLimitModal = () => {
  // 	this.setState({
  // 		imageSizeLimitModal: false,
  // 	})
  // }

  // uploadImageToWordpress = (image) => {
  //   var axios = require('axios')
  //   //authentication
  //   var auth = base64_encode('yousaydev' + ':' + 'Manayousay@21')

  //   var data = new FormData()
  //   data.append('file', image)

  //   var config = {
  //     method: 'post',
  //     url: 'https://yousaydev.ktree.org/wp-json/wp/v2/media/',
  //     headers: {
  //       'content-disposition': 'form-data;',
  //       Authorization: `Basic ${auth}`,
  //     },
  //     data: data,
  //   }
  //   console.log('inside upload image to wordpress')
  //   axios(config)
  //     .then((response) => {
  //       //201 code for success status
  //       if (response.status == 201) {
  //         console.log(response, 'dataaaaaa')
  //         console.log('image upload success')
  //         //pass the uploaded featuredimage id to main component
  //         if (this.props.setFeaturedImageId) {
  //           this.props.setFeaturedImageId(response.data.id)
  //         }
  //       }
  //       console.log(response.data.id)
  //     })
  //     .catch(function(error) {
  //       console.log(error)
  //     })
  // }
  componentDidMount() {}
  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedContentType !== this.props.selectedContentType ||
      prevProps.shortByteTemplateType !== this.props.shortByteTemplateType
    ) {
      this.setState({
        crop: {
          unit: '%',
          width: 30,
          aspect: this.props.circularCrop
            ? 1
            : this.props.selectedContentType == 'ShortByte' &&
              (this.props.shortByteTemplateType == 'Small' ||
                this.props.shortByteTemplateType == 'Medium')
            ? 9 / 16
            : 16 / 9,
        },
      })
    }
  }

  onSelectFile = e => {
    let pngImageExists = false
    pngImageExists = e?.target?.files[0]?.type?.includes('png')
    // const limitUpload = this.props.type !== 'Story' ? e?.target?.files[0]?.size / 1000 <= 300 : true
    if (!pngImageExists) {
      if (e.target.files && e.target.files.length > 0) {
        const reader = new FileReader()
        reader.addEventListener('load', () => {
          this.setState({
            src: reader.result,
          })
        })
        reader.readAsDataURL(e.target.files[0])
        this.setState({
          cropImage: false,
          selectedImage: e.target.files[0],
          croppedImageUrl: '',
          croppedImage: '',
          imageSizeLimitModal: false,
        })
      }
    } else {
      this.setState({ imageSizeLimitModal: true })
    }
  }

  // If you setState the crop in here you should return false.
  onImageLoaded = image => {
    this.imageRef = image
  }

  onCropComplete = crop => {
    this.makeClientCrop(crop)
  }

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop })
  }

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop, 'newFile.jpeg')
      this.setState({ croppedImageUrl })
    }
  }

  removeSelectedImage = () => {
    this.setState({
      cropImage: false,
      src: null,
      crop: {
        unit: '%',
        width: 30,
        aspect: this.props.circularCrop
          ? 1
          : this.props.selectedContentType == 'ShortByte' &&
            (this.props.shortByteTemplateType == 'Small' ||
              this.props.shortByteTemplateType == 'Medium')
          ? 9 / 16
          : 16 / 9,
      },
      selectedImage: '',
      croppedImageUrl: '',
      croppedImage: '',
    })
  }

  GetDate = () =>
    String(new Date().getFullYear()) +
    ('0' + (new Date().getMonth() + 1)).slice(-2) +
    ('0' + new Date().getDate()).slice(-2)

  uploadSelectedImage = async crop => {
    const randomId = await uuidv4()
    const key = this.props.imageName
      ? 'public/' + this.GetDate() + '/cricketTeams/' + randomId
      : 'public/' + this.GetDate() + '/contents/' + randomId
    const params = {
      key,
      mimeType: this.state.selectedImage.type,
    }
    const preSignedURLObject = await getPreSignedURLForImageService(params)
    const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
    const signedURL = signedURLObject.data.url
    try {
      const formData = new FormData()
      console.log(formData, 'formData== in story')
      Object.keys(signedURLObject.data.fields).forEach(key => {
        formData.append(key, signedURLObject.data.fields[key])
      })
      // Actual file has to be appended last.
      if (crop) {
        formData.append('file', this.state.croppedImage)
      } else {
        formData.append('file', this.state.selectedImage)
      }

      console.log(signedURL, 'signedURL==  in upload 1111')
      console.log(formData, 'form, in upload 1111')
      console.log(this.state.selectedImage, 'form, selectedImage, in upload 1111')

      const response = await axios({
        method: 'post',
        url: signedURL,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      console.log(response, 'response=== in comp')
      if (response.status) {
        const imageObj = {
          imageValue: this.state.croppedImageUrl ? this.state.croppedImageUrl : this.state.src,
          key,
          copyRight: false,
          copyRightText: '',
          shareImage: false,
        }
        this.setState({ src: '', croppedImageUrl: '' })
        if (this.props.imageName) {
          if (this.props.sectionIndex) {
            this.props.pushImageObj(imageObj, this.props.sectionIndex, this.props.imageName)
          } else {
            this.props.pushImageObj(imageObj, this.props.imageName)
          }
        } else {
          this.props.pushImageObj(imageObj, this.props.sectionIndex)
        }

        // converting the cropped blob file to a normal file using new File()
        let croppedFile = ''
        if (crop) {
          const croppedFileName = this.state.croppedImage.name
          croppedFile = new File([this.state.croppedImage], croppedFileName, {
            size: this.state.croppedImage.size,
            type: this.state.croppedImage.type,
          })
        }
        // const imageToUploadToWordpress = crop ? croppedFile : this.state.selectedImage
        // //function to upload image to wordpress
        // this.uploadImageToWordpress(imageToUploadToWordpress)
      }
    } catch (err) {
      console.warn(err, 'err')
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement('canvas')
    const pixelRatio = window.devicePixelRatio
    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    const ctx = canvas.getContext('2d')

    canvas.width = crop.width * pixelRatio * scaleX
    canvas.height = crop.height * pixelRatio * scaleY

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
    ctx.imageSmoothingQuality = 'high'

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    )

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        blob => {
          if (!blob) {
            // reject(new Error('Canvas is empty'));
            console.error('Canvas is empty')
            return
          }

          blob.name = fileName
          window.URL.revokeObjectURL(this.fileUrl)
          this.fileUrl = window.URL.createObjectURL(blob)
          this.setState({ croppedImage: blob })
          resolve(this.fileUrl)
        },
        'image/jpeg',
        1,
      )
    })
  }
  positionval = e => {
    console.log(e.target.value, 'value=========')
    this.setState({ size1: `{e}` })
    console.log(this.state.size1, 'hiimr')
  }
  render() {
    const { src, crop, cropImage, croppedImageUrl } = this.state
    const uploadSingleImage = !(src || croppedImageUrl)
    const uploadButtonVisibility = this.props.multiImages ? true : uploadSingleImage
    return (
      <div>
        {uploadButtonVisibility && (
          <input
            type='file'
            accept='.jpg,.jpeg'
            // accept='image/*'
            onChange={this.onSelectFile}
            style={{ color: 'transparent' }}
          />
        )}
        <div style={{ marignTop: 3, marginBottom: 3 }}>
          <div>
            <img style={{ maxWidth: '100%' }} src={!cropImage ? src : croppedImageUrl} />
          </div>
          {src || croppedImageUrl ? (
            <div key='actionButtons'>
              {!cropImage && (
                <button onClick={() => this.uploadSelectedImage(false)}>Upload Image</button>
              )}
              <div>
                {/* <button onClick={ this.positionval}>Select Image</button> */}

                <select
                  id='imageSize'
                  name='imageSize'
                  onChange={e => this.positionval(e)}
                  value={this.state.size1}
                >
                  <option value='10'>first 1/3 image</option>
                  <option value='11'>second 1/3 image</option>
                  <option value='12'>third 1/3 image</option>
                </select>
                {/* <lable>Position</lable>
								<input type="radio" onClick={this.positionval}/> */}
              </div>
              {!cropImage && (
                <button onClick={() => this.setState({ cropImage: true })}>Crop Image</button>
              )}
              {cropImage && (
                <ReactCrop
                  src={src}
                  crop={crop}
                  ruleOfThirds
                  onImageLoaded={this.onImageLoaded}
                  onComplete={this.onCropComplete}
                  onChange={this.onCropChange}
                  circularCrop={this.props.circularCrop}
                />
              )}
              {croppedImageUrl ? (
                <button onClick={() => this.uploadSelectedImage(true)}>Upload Cropped Image</button>
              ) : null}
              <button onClick={() => this.removeSelectedImage()}>Discard Image</button>
            </div>
          ) : null}
        </div>
        <label htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
          {this.state.imageSizeLimitModal ? 'Only JPG,JPEG Images are allowed' : ''}
        </label>
        {/* <text>{this.state.imageSizeLimitModal ? "Only JPG,JPEG Images are allowed" : ""}</text> */}
        {/* <Modal show={this.state.imageSizeLimitModal} onHide={() => this.hideISizeLimitModal()}>
					<Modal.Body>
						<div className='row'>
							<text>Maximum allowed Image size is 300 Kb</text>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={() => this.hideISizeLimitModal()}>Ok</Button>
					</Modal.Footer>
				</Modal> */}
      </div>
    )
  }
}

export default ImageUpload
